var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      staticClass: "language-switch",
      attrs: { trigger: "click" },
      on: { command: _vm.handleCommand }
    },
    [
      _c(
        "span",
        { staticClass: "switcher", attrs: { title: _vm.currentLang.label } },
        [
          _vm.currentLang.flag
            ? _c("img", {
                staticClass: "lang-flag",
                attrs: { src: _vm.currentLang.flag }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "lang-code" }, [
            _vm._v(_vm._s(_vm.currentLang.header))
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "el-icon-arrow-down" })
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        _vm._l(_vm.languages, function(item) {
          return _c(
            "el-dropdown-item",
            {
              key: item.key,
              class: { "is-active": _vm.locale === item.key },
              attrs: { command: item.key }
            },
            [
              item.flag
                ? _c("img", {
                    staticClass: "lang-flag-inline",
                    attrs: { src: item.flag }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.label))]),
              _vm._v(" "),
              _c("span", { staticClass: "lang-code-inline" }, [
                _vm._v(_vm._s(item.header))
              ])
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5b1c342", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5b1c342","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageSwitch/index.vue
// module id = null
// module chunks = 